import { Route } from "vue-router";

export class ListRequest {
  skip: number = 0;
  take: number | null = 20;

  constructor(route?: Route) {
    this.loadBase(route);
  }

  loadBase(route?: Route) {
    if (route && route.query) {
      if (route.query.skip) {
        this.skip = parseInt(route.query.skip as string);
      }
      if (route.query.take) {
        this.take = parseInt(route.query.take as string);
      }
    }
  }
}
